import classNames from 'classnames'
import { forwardRef, HTMLAttributes } from 'react'

import styles from './table-row.module.scss'

export const TableRowAligns = ['start', 'center', 'end', 'baseline'] as const
export type TableRowAlign = (typeof TableRowAligns)[number]
export type TableRowElement = HTMLTableRowElement

export type TableRowProps = HTMLAttributes<TableRowElement> & {
  align?: TableRowAlign // [TODO] make it responsive prop. @andersonba
}

const TableRow = forwardRef<TableRowElement, TableRowProps>(function TableRow(props, ref) {
  const { className, align, ...rest } = props
  const classes = classNames(
    styles.root,
    {
      [styles.alignStart]: align === 'start',
      [styles.alignCenter]: align === 'center',
      [styles.alignEnd]: align === 'end',
      [styles.alignBaseline]: align === 'baseline',
    },
    className
  )
  return <tr {...rest} className={classes} ref={ref} />
})

export default TableRow
